import Select from '@components/Select'

// atm react-select lib doesn't support `required` prop
// https://github.com/JedWatson/react-select/issues/3140

const RequiredSelect = ({ required, value, ...props }) => (
    <>
        <Select {...props} />
        {required && (
            <input autoComplete="off" className="hidden-input" value={value ? value.value : ''} required={true} />
        )}
    </>
)

export default RequiredSelect
